import { ApiMethods } from "../../constants/apiMethods";
import { DateFormats } from "../../constants/dateFormats";
import { IRequestDetails } from "../../models/requestDetails";
import { IRequestItem } from "../../pages/request/list/item/item";
import { apiFetchOAuthWithClaims } from "../../services/apiClient";
import { getLocalDate } from "../../utils/dateUtils";

const baseURL = process.env.REACT_APP_API_URL;

export class RequestApi {
    async getRequestListList(): Promise<IRequestItem[]> {
        const url = `${baseURL}/requests?date=${getLocalDate(DateFormats.ISO)}`;
        return apiFetchOAuthWithClaims(ApiMethods.GET, url).withBody({}).execute<IRequestItem[]>();
    }

    async getRequestItem(id:number): Promise<IRequestDetails> {
        const url = `${baseURL}/requests/${id}`;
        return apiFetchOAuthWithClaims(ApiMethods.GET, url).withBody({}).execute<IRequestDetails>();
    }

    async patchAddRequest(form:any): Promise<IRequestDetails> {
        const url = `${baseURL}/requests?transportUnitNumber=${form.transportUnitNumber}&date=${form.date}`;
        return apiFetchOAuthWithClaims(ApiMethods.PATCH, url).withBody({}).execute<IRequestDetails>();
    }
}